import React, { useState, useEffect } from "react";
import { Form, Row, Col, TimePicker, Typography } from "antd";
import { DownOutlined } from "@ant-design/icons";
import CustomTitle from "../../components/CustomTitle.jsx";
import moment from "moment";
import { getFormattedUserTimeZone } from "../../common/utils/utils.js";
import CustomSelect from "../../components/CustomSelect.jsx";

const { Text } = Typography;

const FrequencySelector = ({ initialFrequency, form,timezone }) => {
  const [selectedFrequency, setSelectedFrequency] = useState(
    initialFrequency?.value || null
  );
  useEffect(() => {
    if (initialFrequency) {
      form.setFieldsValue({
        frequency: initialFrequency.value,
        day_of_week: initialFrequency.day || undefined,
        send_at_1:
          initialFrequency.time_1 &&
          moment(initialFrequency.time_1, "HH:mm", true).isValid()
            ? moment(initialFrequency.time_1, "HH:mm")
            : undefined,
        send_at_2:
          initialFrequency.time_2 &&
          moment(initialFrequency.time_2, "HH:mm", true).isValid()
            ? moment(initialFrequency.time_2, "HH:mm")
            : undefined,
      });

      setSelectedFrequency(initialFrequency);
    }
  }, [initialFrequency, form]);

  const frequencyOptions = [
    { value: "REALTIME", label: "Real Time" },
    // { value: "BATCHEDALERTS", label: "Batched Alerts" },
    // { value: "15MIN", label: "Every 15 Mins" },
    // { value: "30MIN", label: "Every 30 Mins" },
    // { value: "1HR", label: "Every 1 Hour" },
    { value: "ONCE_A_DAY", label: "Once a day" },
    { value: "TWICE_A_DAY", label: "Twice a day" },
    { value: "WEEKLY", label: "Weekly" },
  ];

  const dayOptions = [
    { value: "Sunday", label: "Sun" },
    { value: "Monday", label: "Mon" },
    { value: "Tuesday", label: "Tue" },
    { value: "Wednesday", label: "Wed" },
    { value: "Thursday", label: "Thu" },
    { value: "Friday", label: "Fri" },
    { value: "Saturday", label: "Sat" },
  ];

  return (
    <Row style={{ marginLeft: "2px" }}>
      <Col span={24}>
        <Form.Item
      className="custom-input form-input-style"
          label="Frequency"
          name="frequency"
          rules={[{ required: true, message: "Please select frequency" }]}
        >
          <CustomSelect
            placeholder="Select"
            onChange={(value) => setSelectedFrequency(value)}
            options={frequencyOptions}
            style={{
              background: "#F3F3F3",
              borderRadius: "8px",
              height: "36px",
            }}
          />
        </Form.Item>
      </Col>

      {(selectedFrequency === "ONCE_A_DAY" ||
        selectedFrequency === "TWICE_A_DAY" ||
        selectedFrequency === "WEEKLY") && (
        <>
          <Col span={24}>
            <CustomTitle
            required
              text={selectedFrequency === "WEEKLY" ? "Send on" : "Send at"}
              fontSize="14px"
              fontWeight="600"
              lineHeight="16px"
              color="black"
              marginTop="5px"
              marginBottom="5px"
            />
          </Col>

          <Row gutter={10} style={{ width: "100%" }}>
            {selectedFrequency === "WEEKLY" && (
              <Col span={11}>
                <Form.Item
                  name="day_of_week"
                  rules={[{ required: true, message: "Please select a day" }]}
                >
                  <CustomSelect
                    suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                    placeholder="Select Day"
                    options={dayOptions}
                    style={{
                      background: "#F3F3F3",
                      borderRadius: "8px",
                      height: "40px",
                    }}
                  />
                </Form.Item>
              </Col>
            )}

            {selectedFrequency === "WEEKLY" && (
              <Col>
                <Text
                  style={{
                    fontSize: "16px",
                    color: "black",
                    position: "relative",
                    top: "10px",
                  }}
                >
                  at
                </Text>
              </Col>
            )}

            <Col span={11}>
              <Form.Item
                name={
                  selectedFrequency === "WEEKLY" ? "send_at_2" : "send_at_1"
                }
                rules={[{ required: true, message: "Please select a time" }]}
              >
                <TimePicker
                  style={{
                    border: "none",
                    height: "40px",
                    background: "#F3F3F3",
                    borderRadius: "8px",
                    width: "100%",
                  }}
                  suffixIcon={
                    <DownOutlined
                      style={{ color: "#5E5E5E", fontSize: "12px" }}
                    />
                  }
                  use12Hours
                  format="h:mm a"
                />
              </Form.Item>
            </Col>

            {selectedFrequency === "TWICE_A_DAY" && (
              <>
                <Col>
                  <Text
                    style={{
                      fontSize: "16px",
                      color: "black",
                      position: "relative",
                      top: "10px",
                    }}
                  >
                    &
                  </Text>
                </Col>
                <Col span={11}>
                  <Form.Item
                    name="send_at_2"
                    rules={[
                      { required: true, message: "Please select a time" },
                    ]}
                  >
                    <TimePicker
                      style={{
                        border: "none",
                        height: "40px",
                        background: "#F3F3F3",
                        borderRadius: "8px",
                        width: "100%",
                      }}
                      suffixIcon={
                        <DownOutlined
                          style={{ color: "#5E5E5E", fontSize: "12px" }}
                        />
                      }
                      use12Hours
                      format="h:mm a"
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
        </>
      )}

      {(selectedFrequency === "ONCE_A_DAY" ||
        selectedFrequency === "TWICE_A_DAY" ||
        selectedFrequency === "WEEKLY") && (
        <Text
          style={{
            fontSize: "12px",
            color: "#5E5E5E",
            position: "relative",
            top: "-5px",
          }}
        >
     {getFormattedUserTimeZone()}
        </Text>
      )}
    </Row>
  );
};

export default FrequencySelector;
